import { Link } from '../lib/Link'
import { DesktopNavigation, MobileNavigation } from '../components/Navigation'

export default function NotFound() {
  return (
    <>
      <main className="bg-bg text-white min-h-screen">
        <div className="flex-1">
          <DesktopNavigation />
          <div className="p-4 lg:p-6 max-w-xl">
            <h1 className="text-3xl font-semibold opacity-40 mb-2">404</h1>
            <p className="opacity-80 mb-6">This page doesn’t exist.</p>
            <Link
              href="/planning"
              className="inline-block bg-green-700 hover:bg-green-800 rounded-full px-6 py-3"
            >
              Back to planning
            </Link>
          </div>
        </div>
      </main>
      <MobileNavigation />
    </>
  )
}
